import React, {useRef, useState, useEffect } from 'react';
import {Row, Col, Card, Button, Form, Spinner, Table, Dropdown, ButtonGroup, DropdownButton, Modal} from 'react-bootstrap';
import {listStaff, remove} from '../../../lib/api/clubStaff';
import classNames from "classnames";
import Flex from "../../common/Flex";
import CardDropdown from "../../common/CardDropdown";
import {Add} from "./AddStaff";
import Avatar from "../../common/Avatar";
import SubtleBadge from 'components/common/SubtleBadge';
import { useAppContext } from 'providers/AppProvider';
import {toast} from "react-toastify";

export function List({ initialData, initMode, onClose, onSave }) {
  console.log('initialData',initialData)
  const [club, setClub] = useState(initialData);
  const [mode, setMode] = useState(initMode);
  const [staff, setStaff] = useState([]);
  const [selectedClub, setSelectedClub] = useState({});
  const [selectedStaff, setSelectedStaff] = useState({});
  const [staffType, setStaffType] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const {userApp} = useAppContext();

  const getClubsList = async () => {
    const resStaff = await listStaff(club.club_guid);
      setStaff(resStaff);
  }
  useEffect(() => {
    (async () => {
      await getClubsList();
    })();
  }, [club]);

  const handleAdd = (data) => {
    setStaffType(data);
    setSelectedClub(club);
    setShowModal(true);
  };

  const handelDelete = async (id, name) => {
    if (confirm(`Da li ste sigurni da želite da izbrišete osoblje ${name}?`)) {
        try {
            await remove(id);
            setStaff((prev) => prev.filter((p) => p.clubs_staff_guid !== id));
        }catch (err){
            toast.error(
                <span>
                    <p>Došlo je do greške.</p>
                    <p>{err.body?.message || err.message}</p>
                </span>
            );
        }
    }
  };

  const renderActions = item => (
    <CardDropdown>
      <div className="py-2">
        <Dropdown.Item onClick={() => handelDelete(item.clubs_staff_guid, item.name + ' ' + item.last_name)}>
          Izbriši
        </Dropdown.Item>
      </div>
    </CardDropdown>
  );

  return (
      <Card className={classNames('h-100')}>
        <Card.Header>
          <Row className={classNames('g-2')}>
            <Col>
              <Flex>
                <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">
                  {club.club_name}
                </h5>
              </Flex>
            </Col>
            <Col xs="auto">
              <ButtonGroup vertical>
                <DropdownButton  variant="primary" as={ButtonGroup} title="Dodaj osoblje" id="bg-vertical-dropdown-1">
                    <Dropdown.Item onClick={() => handleAdd({ clubs_staff_type_id: 1 })} eventKey="1">Trenera</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleAdd({"clubs_staff_type_id":2})} eventKey="2">Pomoćni trener</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleAdd({"clubs_staff_type_id":3})} eventKey="3">Doktor</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleAdd({"clubs_staff_type_id":4})} eventKey="3">Fizioterapeut</Dropdown.Item>
                </DropdownButton>
              </ButtonGroup>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="bg-body-tertiary">
          {isLoading ? (
              <div className="text-center">
                <Spinner animation="border" role="status" />
              </div>
          ) : (
              <Row className="mb-3">
                <div className="d-none d-xl-block">
                  <Table responsive>
                    <thead>
                    <tr>
                      <th scope="col">Ime i prezime</th>
                      <th className="text-end" scope="col">Akcija</th>
                    </tr>
                    </thead>
                    <tbody>
                    {staff.map((item, i) => (
                        <tr key={i}>
                          <td className="text-nowrap">
                            <div className="d-flex align-items-center">
                              <Avatar src={process.env.REACT_APP_BASE_API_URL + `/uploads/${item.image_path}`} size="xl" name={item.name} />
                              <div className="ms-2">{item.ent_name} <small>({item.type_name})</small></div>
                            </div>
                          </td>
                          <td className="text-end">{renderActions(item)}</td>
                        </tr>
                    ))}
                    </tbody>
                  </Table>
                </div>

                <div className="d-xl-none">
                  <Row className="g-3">
                    {staff.map((item, i) => (
                      <Col xs={12} key={i}>
                        <div
                          className="border rounded-4 bg-white h-100 p-3 shadow-sm"
                          style={{ borderColor: '#dfe3ee' }}
                        >
                          <div className="d-flex align-items-start justify-content-between gap-3">
                            <div className="flex-shrink-0">
                              <Avatar
                                src={process.env.REACT_APP_BASE_API_URL + `/uploads/${item.image_path}`}
                                size="2xl"
                                name={item.name}
                              />
                            </div>
                            <div className="flex-shrink-0">{renderActions(item)}</div>
                          </div>

                          <div className="mt-3">
                            <div className="fw-semibold text-dark fs-8">{item.ent_name}</div>
                            {item.type_name && (
                              <div className="mt-2">
                                <span className="badge rounded-pill badge-subtle-primary">
                                  {item.type_name}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Row>
          )}
        </Card.Body>

        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Dodaj igrače</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedClub ? (
                <Add
                    initialData={selectedClub}
                    initStaffType ={staffType}
                    onClose={() => setShowModal(false)}
                    onSave={getClubsList}
                />
            ) : null}
          </Modal.Body>
        </Modal>
      </Card>
  );
}
